import api from "./api";
import { jwtDecode } from "jwt-decode";

export const loginUser = async (emailOrPhone, password) => {
  try {
    const response = await api.post("/users/login", { emailOrPhone, password });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Forgot Password API
export const forgotPassword = async (email) => {
  try {
    const response = await api.post("/users/forgot-password", { email });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reset Password API
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post("/users/reset-password", {
      token,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Verify Reset Token API
export const verifyResetToken = async (token) => {
  try {
    const response = await api.get(`/users/verify-reset-token/${token}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getToken = (role = null) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.log('⚠️ Warning: No token found in localStorage');
  }
  return token;
};

export const setToken = (token, role) => {
  // Store the token
  localStorage.setItem("token", token);

  // Also store user role for easy access
  if (role) {
    localStorage.setItem("userRole", role);
  }
};

export const isAuthenticated = (role = null) => {
  const token = getToken(role);
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // convert to seconds

    // If role is specified, also check if token matches the role
    if (role && decoded.role !== role) return false;

    return decoded.exp && decoded.exp > now;
  } catch (error) {
    console.error("Token decode error:", error);
    return false;
  }
};

export const logout = (role = null) => {
  // Clear all tokens
  localStorage.removeItem("token");
  localStorage.removeItem("token_admin");
  localStorage.removeItem("token_user");
};

export const getUserInfoFromToken = () => {
  try {
    const token = getToken();
    if (!token) {
      console.warn("No token found.");
      return null;
    }

    const decoded = jwtDecode(token);
    // console.log("Decoded token:", decoded);

    return {
      userId: decoded.userId,
      userName: decoded.userName,
      phone: decoded.phone || null,
      email: decoded.email || null,
      waPhone: decoded.waPhone || null,
      role: decoded.role || "user",
    };
  } catch (error) {
    console.error("Error extracting user info from token:", error);
    return null;
  }
};

export const isSuperAdmin = () => {
  const userInfo = getUserInfoFromToken();
  return userInfo?.role === "superadmin";
};

export const isAdmin = () => {
  const userInfo = getUserInfoFromToken();
  return userInfo?.role === "admin";
};

export const isAgent = () => {
  const userInfo = getUserInfoFromToken();
  return userInfo?.role === "agent";
};

export const getCurrentUserRole = () => {
  const userInfo = getUserInfoFromToken();
  return userInfo?.role || null;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.put("/users/change-password", { currentPassword, newPassword });
  return response.data;
};

export const changeUsername = async (newUsername) => {
  const response = await api.put("/users/change-username", { newUsername });
  return response.data;
};
